document.addEventListener("DOMContentLoaded", function () {
	const videoBtns = document.querySelectorAll(".video-btn");

	videoBtns.forEach(btn => {
			btn.addEventListener("click", function () {
					const video = this.closest(".p-video__wrapper").querySelector(".video"); // クリックしたボタンに対応するvideoを取得
					let is_playing = !video.paused; // 現在の再生状態を取得

					if (!is_playing) {
							video.play();
							video.setAttribute("controls", "controls"); // 再生時にコントロールを表示
					} else {
							video.pause();
					}

					// 動画が完全に停止（ポスター画像状態）になったらコントロールを非表示
					video.addEventListener("pause", function () {
							if (video.currentTime === 0) {
									video.removeAttribute("controls");
							}
					});
			});
	});
});

//フッター固定ボタンの表示制御
/*
const fixedElement = document.querySelector('.c_fixed-btn'); // 固定要素
const targetElement = document.getElementById('add-sec02'); // 特定の地点を示す要素

window.addEventListener('scroll', () => {
const scrollY = window.scrollY;
const targetPosition = targetElement.offsetTop;
//console.log(scrollY);
if (scrollY > 3200) {
	fixedElement.style.display = 'block'; // 表示
} else {
	fixedElement.style.display = 'none'; // 非表示
}

if (scrollY > targetPosition) {
		fixedElement.style.display = 'none'; // 特定の地点までスクロールしたら非表示
}

});
*/

//購入エリアをページ最下部に複製
const sourceElement = document.getElementById('add-sec01');
const destinationElement = document.getElementById('add-sec02');
destinationElement.innerHTML = sourceElement.innerHTML;